export default "__VITE_ASSET__jyDXkBk$__"